"use strict";
exports.__esModule = true;
var angular = require("angular");
var tree_filter_modal_component_1 = require("../../../tree-filter-modal/tree-filter-modal.component");
var recalc_component_1 = require("../../../recalc/recalc.component");
var add_node_modal_component_1 = require("../../../add-node-modal/add-node-modal.component");
var recycle_bin_component_1 = require("../../../recycle-bin/recycle-bin.component");
var context_menu_directive_1 = require("../../../context-menu/context-menu-directive");
angular.module("smartorg.r6.navs.tree", [
    context_menu_directive_1["default"],
    require('../../../../../../components/share-link/app/js/plumbing/app'),
    tree_filter_modal_component_1["default"],
    recalc_component_1["default"],
    add_node_modal_component_1["default"],
    recycle_bin_component_1["default"]
]).config(['$rootScopeProvider', function ($rootScopeProvider) {
        // modified angularJS $digest iteration limit to 30
        // Default is 10
        // This is related to the level of tree.
        $rootScopeProvider.digestTtl(30);
    }]);
require('./tree-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.navs.tree';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/app/js/plumbing/app.js